import { cbHttp } from "./http.service";

export const uploadFile = async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file);
    
    return cbHttp.post(`/api/file/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}